import React from 'react';
import { motion } from 'framer-motion'; 
import './Hero.css';

const Hero = () => {
  return (
    <section id="home" className="hero">
      <div className="container">
        <motion.div 
          className="hero-content"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div className="hero-badge">⚡ Next-Gen Tech Partner for Modern Businesses</div>
          
          <h1>
            Build the Future of Your Business with{' '}
            <span className="gradient-text">Smart Digital Solutions</span>
          </h1>
          
          <p className="hero-description">
            We architect high-performance web applications, scalable cloud infrastructure, 
            and tailored software systems that empower SMEs to lead the digital economy.
          </p>
          
          <div className="hero-buttons">
            <button className="btn-primary">Get a Free Consultation →</button>
            <button className="btn-secondary">Explore Services</button>
          </div>
          
          <div className="hero-stats">
            <div><strong>50+</strong> Projects Delivered</div>
            <div><strong>99%</strong> Client Satisfaction</div>
            <div><strong>100%</strong> Secure & Scalable</div>
          </div>
        </motion.div>
        
        <motion.div 
          className="hero-visual"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <div className="floating-card">
            {/* Added your complete tech stack: React, Node, .NET, PHP, Laravel, Python, AWS */}
            <div className="tech-icons">
              <span>React</span>
              <span>Node.js</span>
              <span>.NET</span>
              <span>PHP</span>
              <span>Laravel</span>
              <span>Python</span>
              <span>AWS</span>
            </div>
            <div className="floating-elements">
              <div className="float-emoji">🚀</div>
              <div className="float-emoji">💡</div>
              <div className="float-emoji">⚡</div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;